/* eslint-disable default-param-last */
export const UPDATE_LIST = 'CDI_QUERY_UPDATE_LIST'
export const CLEAR_STATE = 'CDI_QUERY_CLEAR_STATE'
export const CLEAR_ALL_STATE = 'CLEAR_ALL_STATE'

type CdiQueryItem = Record<string, unknown>

type CdiQueryState = {
  list: CdiQueryItem[]
}

type Action = {
  type: string
  payload?: CdiQueryItem[]
}

const initState: CdiQueryState = {
  list: []
}

export default (
  state: CdiQueryState = initState,
  action: Action
): CdiQueryState => {
  switch (action.type) {
    case CLEAR_STATE:
    case CLEAR_ALL_STATE:
      return initState
    case UPDATE_LIST:
      return {
        ...state,
        list: action.payload || []
      }
    default:
      return state
  }
}
